import { ref, onUnmounted } from "vue";
export default {
  name: "GlobalLoading",
  emits: ["destroy"],
  setup(props, context) {
    const isVisible = ref(false);
    const show = () => {
      isVisible.value = true;
    };
    const hide = () => {
      isVisible.value = false;
    };
    onUnmounted(() => {
      context.emit("destroy");
    });
    return {
      isVisible,
      show,
      hide
    };
  }
};